module.exports = __webpack_public_path__ + "img/logo-horizontal.bfca6613.svg";